"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { type ComponentProps, Suspense } from "react";
import { withBasePath } from "../../lib/base-path";
import { addTrackingParams } from "../../utils/url-tracking-params";
type CustomLinkProps = ComponentProps<typeof Link> & {
  href: string;
  blank?: boolean;
  locale?: string;
  prefetch?: boolean;
  passParams?: boolean;
};
export function CustomLink(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Suspense><RenderLink {...props} /></Suspense>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function RenderLink(t0) {
  const $ = _c(18);
  let blank;
  let children;
  let href;
  let locale;
  let passParams;
  let props;
  let target;
  if ($[0] !== t0) {
    ({
      href,
      passParams,
      locale,
      blank,
      target,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = blank;
    $[2] = children;
    $[3] = href;
    $[4] = locale;
    $[5] = passParams;
    $[6] = props;
    $[7] = target;
  } else {
    blank = $[1];
    children = $[2];
    href = $[3];
    locale = $[4];
    passParams = $[5];
    props = $[6];
    target = $[7];
  }
  const finalUrl = useBuildUrlWithParams(href, passParams, locale);
  if (target === "_blank" || blank) {
    let t1;
    if ($[8] !== finalUrl) {
      t1 = isAbsoluteURL(finalUrl) ? finalUrl : withBasePath(finalUrl);
      $[8] = finalUrl;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    const anchorHref = t1;
    let t2;
    if ($[10] !== anchorHref || $[11] !== children || $[12] !== props) {
      t2 = <a href={anchorHref} rel="noopener" target="_blank" {...props}>{children}</a>;
      $[10] = anchorHref;
      $[11] = children;
      $[12] = props;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    return t2;
  }
  let t1;
  if ($[14] !== children || $[15] !== finalUrl || $[16] !== props) {
    t1 = <Link href={finalUrl} {...props}>{children}</Link>;
    $[14] = children;
    $[15] = finalUrl;
    $[16] = props;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  return t1;
}
function isAbsoluteURL(url: string) {
  try {
    const urlObj = new URL(url);
    return urlObj.protocol !== "";
  } catch {
    return false;
  }
}
function addLocale(href: string, loc?: string) {
  if (!loc) {
    return href;
  }
  return `/${loc}${href}`;
}
function useBuildUrlWithParams(href, passParams, locale) {
  const $ = _c(10);
  const searchParams = useSearchParams();
  if (isAbsoluteURL(href)) {
    let t0;
    if ($[0] !== href || $[1] !== passParams || $[2] !== searchParams) {
      const url = new URL(href);
      if (passParams) {
        addTrackingParams(url.searchParams, searchParams);
      }
      t0 = url.toString();
      $[0] = href;
      $[1] = passParams;
      $[2] = searchParams;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
  let finalPathname;
  let t0;
  if ($[4] !== href || $[5] !== locale || $[6] !== passParams || $[7] !== searchParams) {
    const [pathname, search] = href.split("?");
    finalPathname = addLocale(pathname, locale);
    const urlSearchParams = new URLSearchParams(search || "");
    if (passParams) {
      addTrackingParams(urlSearchParams, searchParams);
    }
    t0 = urlSearchParams.toString();
    $[4] = href;
    $[5] = locale;
    $[6] = passParams;
    $[7] = searchParams;
    $[8] = finalPathname;
    $[9] = t0;
  } else {
    finalPathname = $[8];
    t0 = $[9];
  }
  const searchString = t0;
  return searchString ? `${finalPathname}?${searchString}` : finalPathname;
}